/* eslint-disable */
import {
  Button,
  Tag,
  Dropdown,
  Modal,
  message,
} from "antd";
import React, { useEffect, useState, useRef } from "react";
import "./index.scss";
import {
  MenuOutlined,
  FormOutlined,
  ExclamationCircleOutlined
} from "@ant-design/icons";
import api from "@/utils/api";
import http from "@/utils/http";
import { CustomTable, CustomTableExtend } from "@/hocComponents";
import commonFn from "@/utils/commonFn";
import ContractorAddModal from "./AddModal";
import { useNavigate } from "react-router-dom";

export default function Contractor() {
  const initTableHead = {
    prop: undefined,
    street: undefined,
    contractor: undefined,
    projectIdStr: undefined,
    contractedAmount: undefined,
    paid: undefined,
    requested: undefined,
    co: undefined,
    remaining: undefined,
    startCreateDate: undefined,
    endCreateDate: undefined,
    startCommenceDate: undefined,
    endCommenceDate: undefined,
    startExpectedCompleteTimeDate: undefined,
    endExpectedCompleteTimeDate: undefined,
    startContractDate: undefined,
    endContractDate: undefined,
    status: undefined,
  }
  const [tableHead, setTableHead] = useState(initTableHead);

  const tableFilterFn = (event, key, type = 'Input') => {
    commonFn.tableFilterFn({event, key, type, setTableHead, getTableListFn})
  }

  const navigate = useNavigate();

  const handleMenuClick = (e, record) => {
    switch (e.key) {
      case 'edit':
        const route = `/JobRequests/MajorProjectEdit?id=${record.id}&projectName=${record.contractor}`
        const url = `${window.location.origin}#${route}`;
        window.open(url, "_blank", "noopener,noreferrer");
        break;
    
      default:
        break;
    }
  }

  const initColumns = [
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      hidden: false,
      width: 75,
      align: "center",
      render: (text, record, index) => (
        commonFn.btnAuthorityFlag('View/EditMajorProject') && record.approveType === 2 && (<Dropdown
          menu={{
            items: [
              {
                key: "edit",
                icon: <FormOutlined twoToneColor="#1677FF" />,
                label: <div>View/Edit Major Project</div>,
              },
            ],
            onClick: (e) => handleMenuClick(e, record), // 将 record 传递到事件中
          }}
          trigger={["click"]}
        >
          <MenuOutlined className="col-blue" />
        </Dropdown>) || null
      ),
    },
    // {
    //   title: "Prop",
    //   dataIndex: "prop",
    //   titleType: "Input",
    //   width: 80,
    //   isSorter: true,
    //   sortterMultiple: 2,
    //   onChange: (e) => tableFilterFn(e, 'prop'),
    // },
    {
      title: "Address City",
      dataIndex: "unitName",
      titleType: "Input",
      width: 220,
      isSorter: true,
      sortterMultiple: 3,
      isTooltipFlag: true,
      onChange: (e) => tableFilterFn(e, 'unitName'),
      render: (text, record) => {
        return (
          <>
            {record?.addressCity ? <div>{record.addressCity}</div> : null}
            {record?.stateZip ? <div>{record.stateZip}</div> : null}
          </>
        )
      }
    },
    {
      title: "Project #",
      dataIndex: "projectIdStr",
      titleType: "Input",
      width: 120,
      hidden: true,
      isSorter: true,
      sortterMultiple: 3,
      onChange: (e) => tableFilterFn(e, 'projectIdStr'),
    },
    {
      title: "Project Name",
      dataIndex: "projectName",
      titleType: "Input",
      width: 120,
      isSorter: true,
      sortterMultiple: 3,
      onChange: (e) => tableFilterFn(e, 'projectName'),
    },
    {
      title: "Contractor",
      dataIndex: "contractor",
      titleType: "Input",
      isSorter: true,
      sortterMultiple: 3,
      isTooltipFlag: true,
      onChange: (e) => tableFilterFn(e, 'contractor'),
    },
    {
      title: "Total Cost",
      dataIndex: "grandTotal",
      titleType: "",
      isAmountFlag: true,
    },
    // {
    //   title: "P. Requested",
    //   dataIndex: "requestAmount",
    //   titleType: "",
    //   isAmountFlag: true,
    //   onChange: (e) => tableFilterFn(e, 'requestAmount'),
    // },
    {
      title: "Remaining",
      dataIndex: "remainingAmount",
      titleType: "",
      isAmountFlag: true,
      onChange: (e) => tableFilterFn(e, 'remainingAmount'),
    },
    {
      title: "Paid Contractor",
      dataIndex: "payContractorAmount",
      titleType: "",
      isAmountFlag: true,
    },
    {
      title: "CO",
      dataIndex: "co",
      titleType: "",
      isAmountFlag: true,
      onChange: (e) => tableFilterFn(e, 'co'),
    },
    {
      title: "Original Contract",
      dataIndex: "amount",
      titleType: "",
      isAmountFlag: true,
      onChange: (e) => tableFilterFn(e, 'amount'),
    },
    {
      title: "Paid Other",
      dataIndex: "payOtherAmount",
      titleType: "",
      isAmountFlag: true,
    },
    // {
    //   title: 'Create Date',
    //   dataIndex: "createTime",
    //   titleType: "RangePicker",
    //   onChange: (e) => tableFilterFn(e, ['startCreateDate', 'endCreateDate'], 'RangePicker'),
    // },
    {
      title: 'Completion Date',
      dataIndex: "expectedCompleteTime",
      titleType: "RangePicker",
      onChange: (e) => tableFilterFn(e, ['startExpectedCompleteTimeDate', 'endExpectedCompleteTimeDate'], 'RangePicker'),
    },
    {
      title: 'Commence Date',
      dataIndex: "commenceDate",
      titleType: "RangePicker",
      onChange: (e) => tableFilterFn(e, ['startCommenceDate', 'endCommenceDate'], 'RangePicker'),
    },
    {
      title: "P.M",
      dataIndex: "managerName",
      titleType: "Input",
      width: 120,
      isSorter: true,
      sortterMultiple: 3,
      onChange: (e) => tableFilterFn(e, 'managerName'),
    },
    // {
    //   title: 'Contract Date',
    //   dataIndex: "contractDate",
    //   titleType: "RangePicker",
    //   onChange: (e) => tableFilterFn(e, ['startContractDate', 'endContractDate'], 'RangePicker'),
    // },
    {
      title: 'Approve Type',
      dataIndex: 'approveType',
      key: 'approveType',
      align: "center",
      render: (text) => {
        const approveTypeMatch = {
          0: {
            label: 'Pending',
            color: 'blue'
          },
          1: {
            label: 'Waiting For admin Approval',
            color: 'blue'
          },
          2: {
            label: 'Approved',
            color: 'green'
          },
          3: {
            label: 'Reject',
            color: 'red'
          },
          4: {
            label: 'Vendor deleted',
            color: 'red'
          },
          5: {
            label: 'Admin deleted',
            color: 'red'
          },
          6: {
            label: 'Owner deleted',
            color: 'red'
          },
        }
        const item = approveTypeMatch[text  || 0]
        return (
          <Tag color={item.color}>{item.label}</Tag>
        )           
      },
    },
    {
      title: 'Status',
      dataIndex: "status",
      titleType: 'Select',
      isSorter: true,
      sortterMultiple: 3,
      selectOptions: [
        { label: "Open", value: 1 },
        { label: "Close", value: 2 },
      ],
      onChange: e => tableFilterFn(e, 'status', 'Select'),
      render: (text, record) => {
        const {id, } = record
        const isOpen = text === 1;
        const handleClick = () => {
          Modal.confirm({
            title: "Confirm Status Change",
            content: (
              <span>
                Are you sure you want to change the status to
                <span style={{ color: "#1890ff", fontWeight: 500 }}>
                  {isOpen? " Close" : " Open"}
                </span>
                ?
              </span>
            ),
            okText: "Confirm",
            cancelText: "Cancel",
            style: {
              top: "40%",
            },
            onOk: async () => {
                const response = await http.post(api.updateContractStatus, {id, status: isOpen ? 2 : 1});
                if (response?.code === "1") {
                  message.success("Status updated successfully");
                  setTableHead(pre => {
                    getTableListFn(pagination.current, pagination.pageSize, pre);
                    return pre
                  })
                }
            },
          });
        };
        return (
          <Tag
            color={isOpen ? "green" : "red"}
            style={{ cursor: "pointer" }}
            onClick={handleClick}
          >
            { isOpen ? "Open" : "Close" }
          </Tag>
        );
      },
    },
  ];

  const [columns, setColumns] = useState([]);
  const [refreshKey, setRefreshKey] = useState(0);
  const [tableList, setTableList] = useState([]);
  const [tableLoading, setTableLoading] = useState(false);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 25,
    total: 0,
  });
  // 获取列表数据
  const getTableListFn = async (current, pageSize, tableHead = {}) => {
    setTableLoading(true);
    const params = {
      page: current || pagination.current,
      count: pageSize || pagination.pageSize,
      ...tableHead
    };
    const response = await http.post(api.getAdminContractList, params);
    if (response?.code !== "1") {
      commonFn.modalFailedFn(response)
      setTableLoading(false);
      return
    }
    const list = (response.data.list || []).map((item, index) => ({ ...item, '#': (params.page - 1) * params.count + index + 1}));
    setTableList(list);
    setContractRowKey([])
    setContractApproveDisable(false)
    setContractDeleteDisable(false)
    setContractEditDisable(false)
    setPagination((prev) => ({
      ...prev,
      total: response.data.total || 0,
      current: params.page,
      pageSize: params.count,
    }));
    setTableLoading(false);
  };

  const initColunmsFn = () => {
    setTableHead(initTableHead);
    setColumns(initColumns);
  }

  const submitInitFn = () => {
    initColunmsFn()
    getTableListFn(pagination.current, pagination.pageSize, tableHead);
  }

  useEffect(() => {
    initColunmsFn()
    getTableListFn(1, 25)
  }, [refreshKey])

  // ContractorAddModal
  // ContractorAddModal
  const contractRef = useRef(null);
  const [contractRowKey, setContractRowKey] = useState([]);
  const [contractApproveDisable, setContractApproveDisable] = useState(false);
  const [contractDeleteDisable, setContractDeleteDisable] = useState(false);
  const [contractEditDisable, setContractEditDisable] = useState(false);

  const btnListDocFn = ({btnList}) => {
    return (
      <span className='btnList'>
        {
          btnList.map(item => (
            <commonFn.BtnAuthorityFn authKey={item.authKey}>
              <Button 
                className="btnItem" 
                onClick={() => btnListClickFn(item)}
                icon={
                  <img className="img" src={require(`@/assets/images/contractor/${item.icon}.png`)} alt="" />
                }
                disabled={item.disabled}
              >{item.label}
              </Button>
            </commonFn.BtnAuthorityFn>
          ))
        }
      </span>
    )
  }

  const btnListClickFn = (item) => {
    const {type, icon, modalName} = item
    const contractFlag = ['contractApprove', 'contractView', 'contractEdit', 'contractDelete'].includes(type) && !contractRowKey.length
    if(contractFlag){
      message.warning("Please select at least one item.");
      return
    }
    switch (type) {
      case 'contractAdd':
      case 'contractApprove':
      case 'contractView':
      case 'contractEdit':
        contractRef.current.openModal(icon, modalName)
        break;
      case 'contractDelete':
        secondConfirmFn(type)
        break;
      default:
        break;
    }
  }

  const [selectStatus, setSelectStatus] = useState(0);

  const contractBtnList = (contractApproveDisable = false, contractEditDisable = false, contractDeleteDisable = false) => {
    return (
      [
        {
          label: 'New Major Project',
          icon: 'add',
          type: 'contractAdd',
          authKey: 'NewMajorProject',
          modalName: 'New Major Project'
        },
        {
          label: 'Approve',
          icon: 'approve',
          type: 'contractApprove',
          modalName: 'Major Project',
          authKey: 'Approve',
          disabled: contractApproveDisable
        },
        {
          label: 'View',
          icon: 'view',
          type: 'contractView',
          modalName: 'View Major Project',
          authKey: 'View',
        },
        {
          label: 'Edit',
          icon: 'edit',
          type: 'contractEdit',
          modalName: 'Edit Major Project',
          authKey: 'Edit',
          disabled: contractEditDisable
        },
        {
          label: 'Delete',
          icon: 'delete',
          type: 'contractDelete',
          authKey: 'Delete',
          disabled: contractDeleteDisable
        }
      ]
    )
  }

  const secondConfirmFn = () => {
    const statusMatch = {
      2: 7,
      3: 5,
    }
    Modal.confirm({
      title: 'Delete contract',
      icon: <ExclamationCircleOutlined />,
      content: `Are you sure you want to delete the selected data?`,
      okText: 'Sure',
      cancelText: 'Cancel',
      onOk: async() => {
        const response = await http.post(api.delContract, {
          id: contractRowKey[0], 
          approveType: statusMatch[selectStatus],
        });
        if (response?.code === "1") {
          message.success('Deleted successfully');
          getTableListFn()
        } else {
          setTimeout(() => {
            commonFn.modalFailedFn(response)
          }, 500);
        }
      },
      onCancel() {
        console.log('Cancel');
      },
      style: {
        top: '40%',
      },
    });
  }

  const downLoadFn = async() => {
    const blob = await http.post(api.contractDownloadExcel, tableHead, { responseType: 'blob' });
    return {
      blob,
      name: 'Major_Project'
    }
  }

  return (
    <div>
      <CustomTableExtend
        columns={columns}
        setColumns={setColumns}
        initColumns={initColumns}
        refreshKey={refreshKey}
        setRefreshKey={setRefreshKey}
        noShowList={[!commonFn.btnAuthorityFlag('Download') && 'download']}
        downLoadFn={() => downLoadFn()}
      >
        {
          btnListDocFn({
            btnList: contractBtnList(contractApproveDisable, contractEditDisable, contractDeleteDisable),
            borderFlag: true,
          })
        }
      </CustomTableExtend>
      <CustomTable 
        refreshKey={refreshKey}
        tableLoading={tableLoading}
        columns={columns}
        tableList={tableList}
        pagination={pagination}
        setTableHead={setTableHead}
        getTableListFn={getTableListFn}
        tableScrollY="350px"
        rowKey={'id'}
        rowSelection={{ 
          type: 'radio',
          selectedRowKeys: contractRowKey,
          onChange: (selectedRowKeys, selectedRows) => {
            setContractRowKey(selectedRowKeys)
            const {isApprove, isEdit, isDelete, approveType} = selectedRows[0]
            setContractApproveDisable(!isApprove)
            setContractEditDisable(!isEdit)
            setContractDeleteDisable(!isDelete)
            setSelectStatus(approveType)
          },
        }}
        tableCss="maintenanceTable"
      />
      <ContractorAddModal
        ref={contractRef}
        id={contractRowKey[0]}
        submitInitFn={submitInitFn}
      />
    </div>
  );
}
